import {FC, useCallback, useMemo, useState} from 'react';
import {ProcessComment, ProcessCommentManage} from '../../../../../models';
import {useComments} from '../../../../../hooks/services/useComments';
import {Richtext} from '../../../../common/Richtext';
import styles from './Feedback.module.scss';
import { TheButton } from '../../../../common/TheButton';
import { TooltipHost } from '@fluentui/react';

interface IFeedbackReplyToProps {
  isOpen: boolean;
  comment: ProcessComment | ProcessCommentManage;
  processId: number;
  isResolvingMode?: boolean;
  level?: number;
  refresh: (skipLoading?: boolean) => void;
}

export const FeedbackReplyTo: FC<IFeedbackReplyToProps> = ({
  isOpen,
  comment,
  processId,
  isResolvingMode,
  refresh,
  level,
}) => {
  const stylesReplies: React.CSSProperties = {marginLeft: `calc(5% * ${level} + 20px)`};
  const {replyToComment} = useComments();
  const [isLoading, setIsLoading] = useState(false);
  const [content, setContent] = useState('');
  const [counter, setCounter] = useState(1);
  const onAdd = useCallback(() => {
    (async () => {
      setIsLoading(true);
      await replyToComment(isResolvingMode,processId, comment.id, content);
      setContent('');
      setCounter(counter + 1);
      await refresh();
      setIsLoading(false);
    })();
  }, [comment, replyToComment, counter, refresh, content, processId, isResolvingMode]);

  const isContentEmpty = useMemo(():boolean => {
  if (!content) return true

  const stripped = content
    .replace(/<br\s*\/?>/gi, '') 
    .replace(/&nbsp;/gi, '') 
    .replace(/\s+/g, ' ') 
    .trim();
  const textOnly = stripped.replace(/<[^>]*>/g, '').trim();
  return textOnly === '';
},[content])


  return (
    <>
    {isOpen &&
      <>
      <div style={{...stylesReplies}} className={styles.richTextContainer}>
        <Richtext key={counter} onChange={setContent} disable={isLoading} />
      </div>
      <div className={styles.footer}>
    <div className={styles.rightButtons}>
      <TooltipHost content={isContentEmpty ? "A comment is required" : ""}>
          <TheButton primary disabled={isLoading || isContentEmpty} onClick={onAdd}>
            {isResolvingMode ? "Resolve" : "Reply To"}
          </TheButton>
          </TooltipHost>
    </div>
  </div>
      </>
}
 </>  
  );
};
